import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { FuelPricesPerLiter } from '../domain/expenses';
import { fetchStorageJson } from '../services/firebaseStorage';

interface FuelPricesDocument {
  scrapedAt: string;
  sourceUpdatedAt: string;
  source: string;
  currency: 'EUR';
  pricePerLiter: { petrol: number; diesel: number; lpg: number | null };
}

/** Current Bulgaria petrol/diesel price (EUR/liter), scraped into `fuel-prices/latest.json` by the backend. */
export function useFuelPrices(): UseQueryResult<FuelPricesPerLiter> {
  return useQuery({
    queryKey: ['fuelPrices'],
    queryFn: async () => {
      const doc = await fetchStorageJson<FuelPricesDocument>('fuel-prices/latest.json');
      return { petrol: doc.pricePerLiter.petrol, diesel: doc.pricePerLiter.diesel };
    },
    staleTime: 1000 * 60 * 60, // upstream updates at most every few days, no need to refetch often
  });
}
